import React from 'react'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { ConstructionPhaseOption } from '../../../../../../../@types/dropdown-types'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const ConstructionPhase: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-half padding-right-m',
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='construction-phase'
        name='constructionPhase'
        label='wizard.screen.otherFacilities.constructionPhase'
        value={insertionData.constructionPhase}
        noInformation={ConstructionPhaseOption.NO_INFORMATION}
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.constructionPhaseOptions',
          options: Object.keys(ConstructionPhaseOption),
        }}
        onChange={(value) => onChange({ screen: screenName, property: 'constructionPhase' }, value.value!)}
        allowEmpty
      />
    </div>
  )
}

export default ConstructionPhase
